"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _canI = require("../canI");

var _uuid = require("../uuid");

var _ThemeProvider = require("../ThemeProvider");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return hash parameters from url
 * TODO: This function has a lot of eslint issues
 * can somebody help me to fix it at some point?
 */
var getHashParams = function getHashParams() {
  if ((0, _canI.canIExecuteClientCode)()) {
    for (var n, e = {}, o = /\+/g, r = /([^&;=]+)=?([^&;]*)/g, // eslint-disable-next-line no-shadow
    t = function t(n) {
      return decodeURIComponent(n.replace(o, " "));
    }, a = window.location.hash.substring(1); n = r.exec(a);) {
      e[t(n[1])] = t(n[2]);
    } // eslint-disable-next-line no-undef
    // eslint-disable-next-line block-scoped-var


    return e;
  }

  return {};
};

var buildClass = function buildClass(props) {
  var direction = "";
  var tokenTheme = null;
  var options = props.options;

  if (options) {
    if (options.direction) direction = options.direction;
    if (options.theme) tokenTheme = options.theme;
  }

  var mapper = function mapper(clase, prop, className) {
    return !clase.includes(prop) && (!props.className || props.className && !props.className.includes(prop)) ? "".concat(clase, " ").concat(prop) : clase;
  };
  /**
   * Checks is a given style is being registered or not
   * this is needed because we don't want to create the
   * styles over and over again
   * @param {*} styleId
   */


  var isDynamicGeneratedStyleRegistered = function isDynamicGeneratedStyleRegistered(styleId) {
    if ((0, _canI.canIExecuteClientCode)()) {
      if (!window.FR) {
        window.FR = {};
      }

      if (!window.FR.__registeredDynamicGeneratedStyles) {
        window.FR.__registeredDynamicGeneratedStyles = {};
      }

      if (window.FR.__registeredDynamicGeneratedStyles[styleId]) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  };
  /**
   * Register a given style
   * this is needed because we don't want to create the
   * styles over and over again
   * @param {*} styleId
   */


  var registerDynamicGeneratedStyles = function registerDynamicGeneratedStyles(styleId) {
    if ((0, _canI.canIExecuteClientCode)()) {
      if (!window.FR) {
        window.FR = {};
      }

      if (!window.FR.__registeredDynamicGeneratedStyles) {
        window.FR.__registeredDynamicGeneratedStyles = {};
      }

      if (!window.FR.__registeredDynamicGeneratedStyles[styleId]) {
        window.FR.__registeredDynamicGeneratedStyles[styleId] = 1;
        return true;
      } else {
        return true;
      }
    }

    return false;
  };
  /**
   * Appends dynamic generated styles to the DOM
   * @param {*} styles
   */


  var appendDynamicGeneratedStyles = function appendDynamicGeneratedStyles(styles) {
    if ((0, _canI.canIExecuteClientCode)() && typeof document != "undefined") {
      var element = document.getElementById("frDynamicGeneratedStyles");

      if (element) {
        element.innerHTML = element.innerHTML + " " + styles;
      } else {
        var styleNode = styles;
        var body = document.body || document.getElementsByTagName("body")[0];
        var style = document.createElement("style");
        style.type = "text/css";
        style.id = "frDynamicGeneratedStyles";

        if (style.styleSheet) {
          // This is required for IE8 and below.
          style.styleSheet.cssText = styleNode;
        } else {
          style.appendChild(document.createTextNode(styleNode));
        }

        body.appendChild(style);
      }
    }
  };
  /**
   * Static map for prop to classes mapping
   */


  var propNamesToCssPropertiesMap = {
    fontSize: "font-size",
    margin: "margin",
    marginRight: "margin-right",
    marginLeft: "margin-left",
    marginTop: "margin-top",
    marginBottom: "margin-bottom",
    marginHeight: "1",
    marginWidth: "1",
    padding: "padding",
    paddingRight: "padding-right",
    paddingLeft: "padding-left",
    paddingTop: "padding-top",
    paddingBottom: "padding-bottom",
    paddingHeight: "1",
    paddingWidth: "1",
    linearGradient: "linear-gradient",
    radialGradient: "radial-gradient",
    lineHeight: "line-height"
  };
  /**
   * Generates styles for a set of properties
   * this is needed because the functional library is to rigid
   * @param {*} className
   * @param {*} propName
   * @param {*} propValue
   */

  var generateStyles = function generateStyles(className, propName, propValue) {
    var cssProperty = propNamesToCssPropertiesMap[propName];

    if (propName === "marginWidth") {
      return ".".concat(className, " { margin-left: ").concat(propValue, "; margin-right: ").concat(propValue, "; }");
    } else if (propName === "marginHeight") {
      return ".".concat(className, " { margin-top: ").concat(propValue, "; margin-bottom: ").concat(propValue, "; }");
    } else if (propName === "paddingWidth") {
      return ".".concat(className, " { padding-left: ").concat(propValue, "; padding-right: ").concat(propValue, "; }");
    } else if (propName === "paddingHeight") {
      return ".".concat(className, " { padding-top: ").concat(propValue, "; padding-bottom: ").concat(propValue, "; }");
    } else if (propName === "linearGradient" || propName === "radialGradient") {
      return ".".concat(className, " { ").concat(transformGradientClass(propName, propValue), " }");
    } else if (cssProperty) {
      return ".".concat(className, " { ").concat(cssProperty, ": ").concat(propValue, " }");
    } else {
      console.log("The property ".concat(propName, " has not value in the mapping"));
    }

    return "";
  };
  /**
   * Allows to dynamically generate styles if they are not part
   * of the functional library
   * @param {*} layoutClasess
   * @param {*} functionalGeneratedClass
   * @param {*} propName
   * @param {*} propValue
   */


  var smartMapper = function smartMapper(layoutClasess, functionalGeneratedClass, propName, propValue) {
    if (!layoutClasess.includes(functionalGeneratedClass) && (!functionalGeneratedClass.className || functionalGeneratedClass.className && !functionalGeneratedClass.className.includes(functionalGeneratedClass))) {
      // TODO: The condition was added so that it does not add the `auto`, a blacklist will be added later.
      if (propNamesToCssPropertiesMap[propName] && isNaN(propValue) && propValue !== "auto") {
        var hash = "fr-".concat((0, _uuid.getUuidMin)("".concat(propName).concat(propValue).concat(direction)));
        var generatedStyles = generateStyles(hash, propName, propValue);

        if (!isDynamicGeneratedStyleRegistered(hash)) {
          appendDynamicGeneratedStyles(generatedStyles);
          registerDynamicGeneratedStyles(hash);
        }

        return "".concat(layoutClasess, " ").concat(hash);
      }

      return "".concat(layoutClasess, " ").concat(functionalGeneratedClass);
    } else {
      return layoutClasess;
    }
  };

  var transformGradientClass = function transformGradientClass(type, value) {
    var direction = props.options.direction;
    if (!direction) direction = "ltr"; // The basic gradient is generated since it is compatible with most browsers.
    // Try first and then add the --moz or -webkit if necessary.
    // https://caniuse.com/#search=linear-gradient
    // https://stackoverflow.com/questions/7546638/css3-cross-browser-linear-gradient

    if (type === "linearGradient") {
      if (direction === "rtl") {
        var gradient = value;
        if (/right/.test(value)) gradient = gradient.replace(new RegExp("right", "g"), "left");
        if (/left/.test(value)) gradient = gradient.replace(new RegExp("left", "g"), "right");else {
          var myRegexp = /(-)*\d*\d[0-9]deg/g;
          var match = myRegexp.exec(value);
          var deg = match[0].substring(0, match[0].length - 3);
          var degChanged = (parseInt(deg) - 180) * -1;
          gradient = gradient.replace(new RegExp(deg, "g"), degChanged);
        }
        return "background: -webkit-linear-gradient(".concat(gradient, ");");
      } else return "background: -webkit-linear-gradient(".concat(value, ");");
    } else {
      if (direction === "rtl") {
        var _gradient = value;
        if (/right/.test(value)) _gradient = _gradient.replace(new RegExp("right", "g"), "left");
        if (/left/.test(value)) _gradient = _gradient.replace(new RegExp("left", "g"), "right");
        return "background: radial-gradient(".concat(_gradient, ");");
      } else return "background: radial-gradient(".concat(value, ");");
    }
  };

  var getLayoutBasedStyles = function getLayoutBasedStyles() {
    var marginRight = props.marginRight,
        marginLeft = props.marginLeft,
        marginTop = props.marginTop,
        marginBottom = props.marginBottom,
        marginHeight = props.marginHeight,
        marginWidth = props.marginWidth,
        margin = props.margin,
        paddingRight = props.paddingRight,
        paddingLeft = props.paddingLeft,
        paddingTop = props.paddingTop,
        paddingBottom = props.paddingBottom,
        paddingHeight = props.paddingHeight,
        paddingWidth = props.paddingWidth,
        padding = props.padding,
        paddingSm = props.paddingSm,
        paddingMd = props.paddingMd,
        paddingLg = props.paddingLg,
        paddingXl = props.paddingXl,
        hover = props.hover;
    var layoutClasses = "";
    if (margin) layoutClasses = smartMapper(layoutClasses, "fr-m-".concat(margin), "margin", margin);
    if (marginRight) layoutClasses = smartMapper(layoutClasses, "fr-mr-".concat(marginRight), direction === "ltr" ? "marginRight" : "marginLeft", marginRight);
    if (marginLeft) layoutClasses = smartMapper(layoutClasses, "fr-ml-".concat(marginLeft), direction === "ltr" ? "marginLeft" : "marginRight", marginLeft);
    if (marginTop) layoutClasses = smartMapper(layoutClasses, "fr-mt-".concat(marginTop), "marginTop", marginTop);
    if (marginBottom) layoutClasses = smartMapper(layoutClasses, "fr-mb-".concat(marginBottom), "marginBottom", marginBottom);
    if (marginHeight) layoutClasses = smartMapper(layoutClasses, "fr-my-".concat(marginHeight), "marginHeight", marginHeight);
    if (marginWidth) layoutClasses = smartMapper(layoutClasses, "fr-mx-".concat(marginWidth), "marginWidth", marginWidth);
    if (padding) layoutClasses = smartMapper(layoutClasses, "fr-p-".concat(padding), "padding", padding);
    if (paddingRight) layoutClasses = smartMapper(layoutClasses, "fr-pr-".concat(paddingRight), direction === "ltr" ? "paddingRight" : "paddingLeft", paddingRight);
    if (paddingLeft) layoutClasses = smartMapper(layoutClasses, "fr-pl-".concat(paddingLeft), direction === "ltr" ? "paddingLeft" : "paddingRight", paddingLeft);
    if (paddingTop) layoutClasses = smartMapper(layoutClasses, "fr-pt-".concat(paddingTop), "paddingTop", paddingTop);
    if (paddingBottom) layoutClasses = smartMapper(layoutClasses, "fr-pb-".concat(paddingBottom), "paddingBottom", paddingBottom);
    if (paddingHeight) layoutClasses = smartMapper(layoutClasses, "fr-py-".concat(paddingHeight), "paddingHeight", paddingHeight);
    if (paddingWidth) layoutClasses = smartMapper(layoutClasses, "fr-px-".concat(paddingWidth), "paddingWidth", paddingWidth);
    if (paddingSm) layoutClasses = smartMapper(layoutClasses, "fr-p-sm-".concat(paddingSm), "paddingSm", paddingSm);
    if (paddingMd) layoutClasses = smartMapper(layoutClasses, "fr-p-md-".concat(paddingMd), "paddingMd", paddingMd);
    if (paddingLg) layoutClasses = smartMapper(layoutClasses, "fr-p-lg-".concat(paddingLg), "paddingLg", paddingLg);
    if (paddingXl) layoutClasses = smartMapper(layoutClasses, "fr-p-xl-".concat(paddingXl), "paddingXl", paddingXl);
    if (hover) layoutClasses = mapper(layoutClasses, "fr-component-hover-".concat(hover));
    return layoutClasses;
  };

  var getColorBasedStyles = function getColorBasedStyles() {
    var bgColor = props.bgColor,
        textColor = props.textColor;
    var colorBasedClasses = "";
    if (bgColor) colorBasedClasses = mapper(colorBasedClasses, "fr-bg-".concat(bgColor));
    if (textColor) colorBasedClasses = mapper(colorBasedClasses, "fr-text-".concat(textColor));
    return colorBasedClasses;
  };

  var getBorderBasedStyles = function getBorderBasedStyles() {
    var border = props.border,
        borderColor = props.borderColor,
        borderStyle = props.borderStyle,
        borderWidth = props.borderWidth,
        borderTop = props.borderTop,
        borderRight = props.borderRight,
        borderBottom = props.borderBottom,
        borderLeft = props.borderLeft,
        borderNone = props.borderNone,
        shadow = props.shadow;
    var borderBasedClasses = "";
    if (border) borderBasedClasses = mapper(borderBasedClasses, "fr-border");
    if (borderColor) borderBasedClasses = mapper(borderBasedClasses, "fr-border-".concat(borderColor));
    if (borderStyle) borderBasedClasses = mapper(borderBasedClasses, "fr-border-style-".concat(borderStyle));
    if (borderWidth) borderBasedClasses = mapper(borderBasedClasses, "fr-border-width-".concat(borderWidth));
    if (borderTop) borderBasedClasses = mapper(borderBasedClasses, "fr-border-top");
    if (borderRight) borderBasedClasses = mapper(borderBasedClasses, "fr-border-right");
    if (borderBottom) borderBasedClasses = mapper(borderBasedClasses, "fr-border-bottom");
    if (borderLeft) borderBasedClasses = mapper(borderBasedClasses, "fr-border-left");
    if (borderNone) borderBasedClasses = mapper(borderBasedClasses, "fr-border-0");
    if (shadow) borderBasedClasses = mapper(borderBasedClasses, "fr-shadow-".concat(shadow));
    return borderBasedClasses;
  };

  var getTextBasedStyles = function getTextBasedStyles() {
    var textAlign = props.textAlign,
        textTransform = props.textTransform,
        textTruncate = props.textTruncate,
        fontItalic = props.fontItalic,
        fontWeight = props.fontWeight,
        textMonoSpace = props.textMonoSpace,
        fontName = props.fontName,
        fontSize = props.fontSize,
        fontSizeSm = props.fontSizeSm,
        fontSizeMd = props.fontSizeMd,
        fontSizeLg = props.fontSizeLg,
        fontSizeXlg = props.fontSizeXlg;
    var textAlignBasedClasses = "";
    if (textAlign) textAlignBasedClasses = mapper(textAlignBasedClasses, "fr-text-".concat(textAlign));
    if (textTransform) textAlignBasedClasses = mapper(textAlignBasedClasses, "fr-text-".concat(textTransform));
    if (textTruncate) textAlignBasedClasses = mapper(textAlignBasedClasses, "fr-text-truncate");
    if (typeof fontName === "string") textAlignBasedClasses = mapper(textAlignBasedClasses, "fr-font-name-".concat(fontName.toLocaleLowerCase().replace(/ /g, "-")));
    if (fontItalic) textAlignBasedClasses = mapper(textAlignBasedClasses, "fr-font-italic");
    if (fontWeight) textAlignBasedClasses = mapper(textAlignBasedClasses, "fr-font-weight-".concat(fontWeight));
    if (textMonoSpace) textAlignBasedClasses = mapper(textAlignBasedClasses, "fr-text-monospace");
    if (fontSize) textAlignBasedClasses = smartMapper(textAlignBasedClasses, "fr-font-size-".concat(fontSize, "-x"), "fontSize", fontSize);
    if (fontSizeSm) textAlignBasedClasses = smartMapper(textAlignBasedClasses, "fr-font-size-sm-".concat(fontSizeSm, "-x"), "fontSize", fontSize);
    if (fontSizeMd) textAlignBasedClasses = smartMapper(textAlignBasedClasses, "fr-font-size-md-".concat(fontSizeMd, "-x"), "fontSize", fontSize);
    if (fontSizeLg) textAlignBasedClasses = smartMapper(textAlignBasedClasses, "fr-font-size-lg-".concat(fontSizeLg, "-x"), "fontSize", fontSize);
    if (fontSizeXlg) textAlignBasedClasses = smartMapper(textAlignBasedClasses, "fr-font-size-xlg-".concat(fontSizeXlg, "-x"), "fontSize", fontSize);
    return textAlignBasedClasses;
  };

  var getRoundedBasedStyles = function getRoundedBasedStyles() {
    var rounded = props.rounded,
        roundedRight = props.roundedRight,
        roundedLeft = props.roundedLeft,
        roundedTop = props.roundedTop,
        roundedBottom = props.roundedBottom,
        roundedCircle = props.roundedCircle;
    var roundedBasedClasses = "";
    if (rounded) roundedBasedClasses = mapper(roundedBasedClasses, "fr-rounded-".concat(rounded, "-x"));
    if (roundedTop) roundedBasedClasses = mapper(roundedBasedClasses, "fr-rounded-top-".concat(roundedTop, "-x"));
    if (roundedRight) roundedBasedClasses = mapper(roundedBasedClasses, "fr-rounded-right-".concat(roundedRight, "-x"));
    if (roundedBottom) roundedBasedClasses = mapper(roundedBasedClasses, "fr-rounded-bottom-".concat(roundedBottom, "-x"));
    if (roundedLeft) roundedBasedClasses = mapper(roundedBasedClasses, "fr-rounded-left-".concat(roundedLeft, "-x"));
    if (roundedCircle) roundedBasedClasses = mapper(roundedBasedClasses, "fr-rounded-circle");
    return roundedBasedClasses;
  };

  var getFloatBasedStyles = function getFloatBasedStyles() {
    var floatLeft = props.floatLeft,
        floatRight = props.floatRight,
        floatNone = props.floatNone;
    var floatBasedClasses = "";
    if (floatLeft) floatBasedClasses = mapper(floatBasedClasses, "fr-float-left");
    if (floatRight) floatBasedClasses = mapper(floatBasedClasses, "fr-float-right");
    if (floatNone) floatBasedClasses = mapper(floatBasedClasses, "");
    return floatBasedClasses;
  };

  var getWidthBasedStyles = function getWidthBasedStyles() {
    var width = props.width;
    var widthBasedClasses = "";
    if (width) widthBasedClasses = "fr-w-".concat(width);
    return widthBasedClasses;
  };

  var getFocusBasedStyle = function getFocusBasedStyle() {
    var focusable = props.focusable,
        focusClass = props.focusClass;
    var focusBasedClasses = "";

    if (focusable) {
      if (focusClass) focusBasedClasses = focusClass;else focusBasedClasses = "fr-focus";
    }

    return focusBasedClasses;
  };

  var getHeightBasedStyles = function getHeightBasedStyles() {
    var height = props.height;
    var heightBasedClasses = "";
    if (height) heightBasedClasses = "fr-h-".concat(height);
    return heightBasedClasses;
  };

  var getDisplayBasedStyles = function getDisplayBasedStyles() {
    var display = props.display;
    var displayBasedClasses = "";
    if (display) displayBasedClasses = mapper(displayBasedClasses, "fr-d-".concat(display));
    return displayBasedClasses;
  };

  var getAlignBasedStyles = function getAlignBasedStyles() {
    var align = props.align;
    var alignBasedClasses = "";
    if (align) alignBasedClasses = "fr-align-".concat(align);
    return alignBasedClasses;
  };

  var getJustifyContentStyles = function getJustifyContentStyles() {
    var justifyContent = props.justifyContent;
    var justifyContentClasses = "";
    if (justifyContent) justifyContentClasses = mapper(justifyContentClasses, "fr-justify-content-".concat(justifyContent));
    return justifyContentClasses;
  };

  var getPositionStyles = function getPositionStyles() {
    var position = props.position,
        left = props.left,
        right = props.right,
        top = props.top,
        bottom = props.bottom;
    var positionClasses = "";
    if (position) positionClasses = mapper(positionClasses, "fr-position-".concat(position));
    if (left) positionClasses = mapper(positionClasses, "fr-left-".concat(left));
    if (right) positionClasses = mapper(positionClasses, "fr-right-".concat(right));
    if (top) positionClasses = mapper(positionClasses, "fr-top-".concat(top));
    if (bottom) positionClasses = mapper(positionClasses, "fr-bottom-".concat(bottom));
    return positionClasses;
  };

  var getAlignSelf = function getAlignSelf() {
    var alignSelf = props.alignSelf;
    var alignSelfClasses = "";
    if (alignSelf) alignSelfClasses = mapper(alignSelfClasses, "fr-align-self-".concat(alignSelf));
    return alignSelfClasses;
  };

  var getFlexGrow = function getFlexGrow() {
    var flexGrow = props.flexGrow;
    var flexGrowClasses = "";
    if (flexGrow) flexGrowClasses = mapper(flexGrowClasses, "fr-flex-grow-".concat(flexGrow));
    return flexGrowClasses;
  };

  var getZindex = function getZindex() {
    var zIndex = props.zIndex;
    var zIndexClasses = "";
    if (zIndex) zIndexClasses = mapper(zIndexClasses, "fr-z-index-".concat(zIndex));
    return zIndexClasses;
  };

  var getFlexDirection = function getFlexDirection() {
    var flexDirection = props.flexDirection;
    var flexDirectionClasses = "";
    if (flexDirection) flexDirectionClasses = mapper(flexDirectionClasses, "fr-flex-".concat(flexDirection));
    return flexDirectionClasses;
  };

  var getAlignItems = function getAlignItems() {
    var alignItems = props.alignItems;
    var alignItemsClasses = "";
    if (alignItems) alignItemsClasses = mapper(alignItemsClasses, "fr-align-items-".concat(alignItems));
    return alignItemsClasses;
  };

  var getRtlReverseBasedStyles = function getRtlReverseBasedStyles() {
    var rtlReverse = props.rtlReverse;
    var rtlReverseBasedClasses = "";
    if (rtlReverse) rtlReverseBasedClasses = mapper(rtlReverseBasedClasses, "fr-rtl-reverse");
    return rtlReverseBasedClasses;
  };

  var getFlexShrinkBasedStyles = function getFlexShrinkBasedStyles() {
    var flexShrink = props.flexShrink;
    var flexShrinkClasses = "";
    if (flexShrink) flexShrinkClasses = mapper(flexShrinkClasses, "fr-flex-shrink-".concat(flexShrink));
    return flexShrinkClasses;
  };

  var getRotateBasedStyles = function getRotateBasedStyles() {
    var rotate = props.rotate;
    var rotateClasses = "";

    if (rotate) {
      rotateClasses = mapper(rotateClasses, "fr-rotate");
      return rotateClasses;
    }
  };

  var getFlexBasedStyles = function getFlexBasedStyles() {
    var flex = props.flex,
        flexXs = props.flexXs,
        flexSm = props.flexSm,
        flexMd = props.flexMd,
        flexLg = props.flexLg;
    var flexClasses = "";
    if (flex) flexClasses = mapper(flexClasses, "fr-flex-".concat(flex));
    if (flexXs) flexClasses = mapper(flexClasses, "fr-flex-xs-".concat(flexXs));
    if (flexSm) flexClasses = mapper(flexClasses, "fr-flex-sm-".concat(flexSm));
    if (flexMd) flexClasses = mapper(flexClasses, "fr-flex-md-".concat(flexMd));
    if (flexLg) flexClasses = mapper(flexClasses, "fr-flex-lg-".concat(flexLg));
    return flexClasses;
  };

  var getLinearGradientBasedStyles = function getLinearGradientBasedStyles() {
    var linearGradient = props.linearGradient;
    var linealGradientClass = "";

    if (linearGradient) {
      linealGradientClass = smartMapper(linealGradientClass, "fr-lineal-gradient-".concat((0, _uuid.getUuidMin)()), "linearGradient", linearGradient);
    }

    return linealGradientClass;
  };

  var getRadialGradientBasedStyles = function getRadialGradientBasedStyles() {
    var radialGradient = props.radialGradient;
    var radialGradientClass = "";

    if (radialGradient) {
      radialGradientClass = smartMapper(radialGradientClass, "fr-radial-gradient-".concat((0, _uuid.getUuidMin)()), "radialGradient", radialGradient);
    }

    return radialGradientClass;
  };

  var getCursorBasedStyles = function getCursorBasedStyles() {
    var cursor = props.cursor;
    var cursorClass = "";
    if (cursor) cursorClass = mapper(cursorClass, "fr-cursor-".concat(cursor));
    return cursorClass;
  };

  var getRoundedTopRightBasedStyles = function getRoundedTopRightBasedStyles() {
    var roundedTopRight = props.roundedTopRight;
    var roundedTopRightClass = "";
    if (roundedTopRight) roundedTopRightClass = mapper(roundedTopRightClass, "fr-rounded-top-right-".concat(roundedTopRight, "-x"));
    return roundedTopRightClass;
  };

  var getRoundedTopLeftBasedStyles = function getRoundedTopLeftBasedStyles() {
    var roundedTopLeft = props.roundedTopLeft;
    var roundedTopLeftClass = "";
    if (roundedTopLeft) roundedTopLeftClass = mapper(roundedTopLeftClass, "fr-rounded-top-left-".concat(roundedTopLeft, "-x"));
    return roundedTopLeftClass;
  };

  var getRoundedBottomRightBasedStyles = function getRoundedBottomRightBasedStyles() {
    var roundedBottomRight = props.roundedBottomRight;
    var roundedBottomRightClass = "";
    if (roundedBottomRight) roundedBottomRightClass = mapper(roundedBottomRightClass, "fr-rounded-bottom-right-".concat(roundedBottomRight, "-x"));
    return roundedBottomRightClass;
  };

  var getRoundedBottomLeftBasedStyles = function getRoundedBottomLeftBasedStyles() {
    var roundedBottomLeft = props.roundedBottomLeft;
    var roundedBottomLeftClass = "";
    if (roundedBottomLeft) roundedBottomLeftClass = mapper(roundedBottomLeftClass, "fr-rounded-bottom-left-".concat(roundedBottomLeft, "-x"));
    return roundedBottomLeftClass;
  };

  var getIconColorBasedStyles = function getIconColorBasedStyles() {
    var iconColor = props.iconColor;
    var colorClass = "";
    if (iconColor) colorClass = mapper(colorClass, "fr-i-".concat(iconColor));
    return colorClass;
  };

  var getLineHeightBasedStyles = function getLineHeightBasedStyles() {
    var lineHeight = props.lineHeight;
    var lineHeightClass = "";
    if (lineHeight) lineHeightClass = smartMapper(lineHeightClass, "fr-line-height-".concat(lineHeight), "lineHeight", lineHeight);
    return lineHeightClass;
  };

  var getSettingsHelperBasedClasses = function getSettingsHelperBasedClasses() {
    var settingsPath = props.settingsPath; // Add a validation here to just include this feature when debugMe

    if (settingsPath && (0, _canI.canIExecuteClientCode)()) {
      // eslint-disable-next-line no-use-before-define
      var urlParsedHash = getHashParams(); // eslint-disable-next-line no-prototype-builtins

      if (urlParsedHash.hasOwnProperty("debugMe")) {
        return "fr-s-path fr-s-path-".concat(settingsPath);
      }
    }

    return "";
  };

  var translatePropsStyles = function translatePropsStyles() {
    var className = props.className;
    var finalClasses = "";
    if (className) finalClasses += " ".concat(className);
    var layoutBasedClasses = getLayoutBasedStyles();
    var colorBasedClasses = getColorBasedStyles();
    var borderBasedClasses = getBorderBasedStyles();
    var textBasedClasses = getTextBasedStyles();
    var roundedBasedClasses = getRoundedBasedStyles();
    var floatBasedClasses = getFloatBasedStyles();
    var widthBasedClasses = getWidthBasedStyles();
    var focusBasedClasses = getFocusBasedStyle();
    var heightBasedClasses = getHeightBasedStyles();
    var displayBasedClasses = getDisplayBasedStyles();
    var alignBasedClasses = getAlignBasedStyles();
    var justifyContent = getJustifyContentStyles();
    var positionClasses = getPositionStyles();
    var alignSelfBasedClasses = getAlignSelf();
    var flexGrowBasedClasses = getFlexGrow();
    var zIndexBasedClasses = getZindex();
    var flexDirectionBasedClasses = getFlexDirection();
    var alignItemsBasedClasses = getAlignItems();
    var rtlReverseBasedClasses = getRtlReverseBasedStyles();
    var flexShrinkBasedClasses = getFlexShrinkBasedStyles();
    var rotateBasedClasses = getRotateBasedStyles();
    var flexBasedClasses = getFlexBasedStyles();
    var linealGradientBasedClasses = getLinearGradientBasedStyles();
    var radialGradientBasedClasses = getRadialGradientBasedStyles();
    var cursorBasedClasses = getCursorBasedStyles();
    var roundedTopRightBasedClasses = getRoundedTopRightBasedStyles();
    var roundedTopLeftBasedClasses = getRoundedTopLeftBasedStyles();
    var roundedBottomRightBasedClasses = getRoundedBottomRightBasedStyles();
    var roundedBottomLeftBasedClasses = getRoundedBottomLeftBasedStyles();
    var iconColorBasedClasses = getIconColorBasedStyles();
    var lineHeightBasedClasses = getLineHeightBasedStyles();
    var settingsHelperBasedClasses = getSettingsHelperBasedClasses();
    var dinamicClass = buildDinamicClass();

    if (layoutBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(layoutBasedClasses);
    }

    if (colorBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(colorBasedClasses);
    }

    if (borderBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(borderBasedClasses);
    }

    if (textBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(textBasedClasses);
    }

    if (roundedBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(roundedBasedClasses);
    }

    if (floatBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(floatBasedClasses);
    }

    if (widthBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(widthBasedClasses);
    }

    if (focusBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(focusBasedClasses);
    }

    if (heightBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(heightBasedClasses);
    }

    if (displayBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(displayBasedClasses);
    }

    if (alignBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(alignBasedClasses);
    }

    if (justifyContent) {
      finalClasses = "".concat(finalClasses, " ").concat(justifyContent);
    }

    if (positionClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(positionClasses);
    }

    if (alignSelfBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(alignSelfBasedClasses);
    }

    if (flexGrowBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(flexGrowBasedClasses);
    }

    if (zIndexBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(zIndexBasedClasses);
    }

    if (flexDirectionBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(flexDirectionBasedClasses);
    }

    if (alignItemsBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(alignItemsBasedClasses);
    }

    if (rtlReverseBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(rtlReverseBasedClasses);
    }

    if (flexShrinkBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(flexShrinkBasedClasses);
    }

    if (rotateBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(rotateBasedClasses);
    }

    if (flexBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(flexBasedClasses);
    }

    if (linealGradientBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(linealGradientBasedClasses);
    }

    if (radialGradientBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(radialGradientBasedClasses);
    }

    if (cursorBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(cursorBasedClasses);
    }

    if (roundedTopRightBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(roundedTopRightBasedClasses);
    }

    if (roundedTopLeftBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(roundedTopLeftBasedClasses);
    }

    if (roundedBottomRightBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(roundedBottomRightBasedClasses);
    }

    if (roundedBottomLeftBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(roundedBottomLeftBasedClasses);
    }

    if (iconColorBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(iconColorBasedClasses);
    }

    if (lineHeightBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(lineHeightBasedClasses);
    }

    if (dinamicClass) {
      finalClasses = "".concat(finalClasses, " ").concat(dinamicClass);
    }

    if (settingsHelperBasedClasses) {
      finalClasses = "".concat(finalClasses, " ").concat(settingsHelperBasedClasses);
    }

    return finalClasses;
  };

  var buildDinamicClass = function buildDinamicClass() {
    var _class = "";

    if (props["cmp-styles"] && _typeof(props["cmp-styles"]) === "object" && props["cmp-styles"].constructor === Object) {
      var styles = JSON.parse(JSON.stringify(props["cmp-styles"]));
      Object.keys(styles).map(function (p) {
        var prop = p.replace(/--space--/g, " ").replace(/--point--/g, ".").replace(/--tilde--/g, "~").replace(/--plus--/g, "+").replace(/--hashtag--/g, "#");
        var content = "";

        if (typeof styles[p] === "string") {
          if (prop === "@theme") {
            if (!styles[p].startsWith("@theme:")) styles[p] = "@theme:".concat(styles[p]);
            styles[p] = (0, _ThemeProvider.getValueFromPath)(styles[p], tokenTheme) || {};
          } else if (styles[p].startsWith("@theme:")) {
            if (p.startsWith(":") && (0, _canI.canIExecuteClientCode)()) console.warn("Cannot use cmp-styles={{\"".concat(p, "\":\"").concat(styles[p], "\"}} this is not allowed."));else {
              var valueFromTheme = (0, _ThemeProvider.getValueFromPath)(styles[p], tokenTheme);
              if (valueFromTheme) content = "{".concat(prop, ":").concat(valueFromTheme, "}");else if ((0, _canI.canIExecuteClientCode)()) console.warn("Design token ".concat(styles[p], " not found in theme."));
            }
          } else if (styles[p].includes("@palette:")) {
            var valueFromPalette = (0, _ThemeProvider.getFromPalette)(styles[p], tokenTheme);
            if (valueFromPalette) content = "{".concat(prop, ":").concat(valueFromPalette, "}");else if ((0, _canI.canIExecuteClientCode)()) console.warn("Palette color ".concat(styles[p], " not found in theme."));
          } else content = "".concat(styles[p] ? "{".concat(prop, ":").concat(styles[p], "}") : "");
        }

        if (prop === "@theme" && styles[p] && Array.isArray(styles[p])) {
          styles[p].forEach(function (item) {
            var result = content;
            var newItem = item;
            if (!newItem.startsWith("@theme:")) newItem = "@theme:".concat(newItem);
            newItem = (0, _ThemeProvider.getValueFromPath)(newItem, tokenTheme) || {};
            Object.keys(newItem).map(function (k) {
              result += "".concat(k, ":").concat(newItem[k], ";");
            });
            content = result;
          });
          content = "{".concat(content, "}");
        }

        if (styles[p] && _typeof(styles[p]) === "object" && styles[p].constructor === Object) {
          content = "{".concat(Object.entries(styles[p]).reduce(function (content, _ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                propName = _ref2[0],
                propValue = _ref2[1];

            var result = content;

            if (propName === "@theme") {
              if (propValue && Array.isArray(propValue)) {
                propValue.forEach(function (item) {
                  var result = content;
                  var newItem = item;
                  newItem = (0, _ThemeProvider.getValueFromPath)("@theme:".concat(newItem), tokenTheme) || {};
                  Object.keys(newItem).map(function (k) {
                    result += "".concat(k, ":").concat(newItem[k], ";");
                  });
                  content = result;
                });
                result = content;
              } else {
                var path = propValue;

                if (!propValue.startsWith("@theme:")) {
                  path = "@theme:".concat(path);
                }

                var valueFromPath = (0, _ThemeProvider.getValueFromPath)(path, tokenTheme) || {};
                Object.keys(valueFromPath).map(function (k) {
                  result += "".concat(k, ":").concat(valueFromPath[k], ";");
                });
              }
            } else if (typeof propValue === "string" && propValue.startsWith("@theme:")) {
              var _valueFromPath = (0, _ThemeProvider.getValueFromPath)(propValue, tokenTheme);

              if (_valueFromPath) {
                result = "".concat(content).concat(propName, ":").concat(_valueFromPath, ";");
              } else if ((0, _canI.canIExecuteClientCode)()) {
                console.warn("Design token ".concat(propValue, " not found in theme."));
              }
            } else if (typeof propValue === "string" && propValue.includes("@palette:")) {
              var _valueFromPalette = (0, _ThemeProvider.getFromPalette)(propValue, tokenTheme);

              if (_valueFromPalette) {
                result = "".concat(content).concat(propName, ":").concat(_valueFromPalette, ";");
              } else if ((0, _canI.canIExecuteClientCode)()) {
                console.warn("Palette color ".concat(propValue, " not found in theme."));
              }
            } else if (propValue) {
              result = "".concat(content).concat(propName, ":").concat(propValue, ";");
            }

            return result;
          }, ""), "}");
        }

        content = content && content !== "{}" ? content : null;

        if (content) {
          if (direction === "rtl") content = buildRtl(content);
          var hash = "fr-".concat((0, _uuid.getUuidMin)("".concat(prop).concat(content)));
          var contentClass = ".".concat(hash);
          if (prop.startsWith(":")) contentClass += "".concat(prop).concat(content);else if (prop.startsWith(".") || prop.startsWith("#")) {
            contentClass += " ".concat(prop).concat(content);
          } else if (prop.startsWith("@media")) contentClass = "".concat(prop, "{.").concat(hash).concat(content, "}");else contentClass += content;

          if (!isDynamicGeneratedStyleRegistered(hash)) {
            appendDynamicGeneratedStyles(contentClass);
            registerDynamicGeneratedStyles(hash);
          }

          _class += !_class.includes(hash) ? " ".concat(hash) : "";
        }
      });
    }

    return _class;
  };

  return translatePropsStyles().trim();
};

var buildRtl = function buildRtl(content) {
  return content.replace(/right/g, "l-e-f-t").replace(/left/g, "r-i-g-h-t").replace(/l-e-f-t/g, "left").replace(/r-i-g-h-t/g, "right");
};

var _default = buildClass;
exports["default"] = _default;